module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/oliwia-bernat-fc4c5a0215ac39dff2fc7666b048b878.png";